import React, { Component } from 'react';
import { Link } from 'react-router';
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment';
import {  displayDateFormat, prettyNumberParamsL } from '../../../constants';
import { getAccessToken } from '../../../utils';

export default class FleetSim extends Component{
  constructor(props){
    super(props);
  }
  getAmount = (date) => {
    let cashflowdata = this.props.cashSimulation.cashflow.filter(cashflow => cashflow.date == date );
    return cashflowdata.length ? cashflowdata[0].amount : null ;
  }
  render(){
    const { cashSimulation, monthList } = this.props;
    return(
     <div className="item-block">
        {
          monthList.map((date, index) => {
            let sum = this.getAmount(date);
            return (
              <div key={index} className={ sum < 0 ? 'neg-value item-detail-block': 'item-detail-block'}>
              <p className="para-ui month-detail">
               {sum ? <span className="price-block text-center">  <NumericLabel params={prettyNumberParamsL}>{ sum }</NumericLabel> </span> : <span style={{ display: 'block', textAlign: 'center'}}> -- </span> } 
              </p>
          </div>
            )
          }
        
        
        )}


      </div>
    )
  }
}
